import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class LoggedTimeDetailBus extends BaseBus {
    constructor(busObj: LoggedTimeDetailBus = null) {
        super(busObj);
        if (busObj && busObj.startDate) { this.startDate = DateFunctions.getDate(busObj.startDate); }
        if (busObj && busObj.endDate) { this.endDate = DateFunctions.getDate(busObj.endDate); }
        if (busObj && busObj.retroDt) { this.retroDt = DateFunctions.getDate(busObj.retroDt); }
        if (busObj && busObj.sageDt) { this.sageDt = DateFunctions.getDate(busObj.sageDt); }
    }
    //constructor(busObj: LoggedTimeDetailBus = null) {
    //    super(busObj);
    //    if (CommonFunctions.hasValue(busObj)) {
    //    }
    //}
    CID(): any {
        return this.dispatchLaborId;
    }
    setBeforeSave() {
        if (this.startDate) { this.startDate = DateFunctions.getDateTimeWithUTCOffset(this.startDate); }
        if (this.endDate) { this.endDate = DateFunctions.getDateTimeWithUTCOffset(this.endDate); }
    }
    setId(id: any) {
        this.dispatchLaborId = id;
    }
    setParentId(id: any) {
        // this.timeOffRequestId = id;
    }

    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {

    }

    hours(): any {
        return DateFunctions.dateDiffHours(this.startDate, this.endDate);
    }
    setFromForm(data: LoggedTimeDetailBus) {
        super.setFromForm(data);
        if (data && data.startDate) { this.startDate = DateFunctions.getDate(data.startDate); }
        if (data && data.endDate) { this.endDate = DateFunctions.getDate(data.endDate); }
        if (data && data.retroDt) { this.retroDt = DateFunctions.getDate(data.retroDt); }
        if (data && data.sageDt) { this.sageDt = DateFunctions.getDate(data.sageDt); }
        let dateNow = CommonFunctions.getDateNow();
    }

    dispatchLaborId: any;
    startDate: Date;
    endDate: Date;
    timeType: string;
    payType: string;
    dispatchNumber: string;
    laborMinutes: number;
    personId: any;
    resourceName: string;
    locationName: string;
    city: string;
    addressLine1: string;
    stateProvince: string;
    dispatchId: any;
    quickSearchKey: string;
    timeTypeId: any;
    payTypeId: any;
    nonPaid: boolean;
    empNo: string;
    afterPayroll: boolean;
    useLocationRate: boolean;
    hrsApproved: boolean;
    mgrApproved: boolean;
    sageDt: Date;
    retroDt: Date;
    certPayrollRequired: boolean;
    personState: string;
    payLocalTaxCode: boolean;
    aprvdName: string;
    createName: boolean;
    dispatchReason: string;
    hasSageDt(): any {
        if (!this.sageDt) return false;
        if (this.sageDt < new Date("1/1/1970")) return false;
        return  true;
    }
}

